import dalton from '../client';
import Authorization from '../constants/Authorization';
import { checkAuthorization } from '../utils';

import doUnsetCookie from './doUnsetCookie';

export const DO_LOGOUT_ENDPOINT = '/core/api/1/user/logout';
export const DO_LOGOUT_METHOD = 'POST';
export const DO_LOGOUT_AUTHORIZATIONS = [Authorization.AUTHN];

/**
 * Authenticate an IDS User.
 *
 * Given an Identity, this API will attempt to verify the Identity, and return an AuthToken for that User which has been authorized by this core and any apps which have been specified in the request.
 * Since this API must, by definition, be called by untrusted entities, the responses from this API in the case of an error are intentionally somewhat uninformative.
 * In cases where this core is part of a multi-core federation, there are some impacts on logging in that should be noted. A User may have registered with another core, and therefore, they already have a valid Identity which can be verified by this core. However, that user may not have a profile for this core yet. In cases such as this, where an Identity can be verified, but the User does not have profile for this core, or has a "stub" profile for this core, the login API will return status 222. This should be taken as an indication that the User needs to create a profile.
 * In the case of a successful authentication, the response will have a Content-Type of text/plain, and the response body will contain the IDS AuthToken (e.g.: <tid>|core.authn*10000^newsletter.subscribe*20000^|core*<coreSig>^newsletter*<newsletterSig> ^|<authTokenCreateTimestamp> )
 */
export default async function doLogout(authorizationHeader: string | null) {
    try {
        await doUnsetCookie();
    // eslint-disable-next-line no-empty
    } catch (error) {}

    if (checkAuthorization(authorizationHeader, Authorization.AUTHN)) {
        try {
            await dalton.request<void>({
                data: '',
                headers: {
                    Authorization: authorizationHeader,
                },
                method: DO_LOGOUT_METHOD,
                url: DO_LOGOUT_ENDPOINT,
            });
            // eslint-disable-next-line no-empty
        } catch (error) {}
    }
}
